import { Pipe, PipeTransform } from '@angular/core';
import { numberFormat } from '../app.constants';

@Pipe({
    name: 'filterInfluencerGroupName',
    pure: false
})
export class FilterInfluencerGroupNameSuffixPipe implements PipeTransform {
    transform(items: any[], searchContent): any {
        return searchContent
          ? items.filter(item => item.name.toLowerCase().indexOf(searchContent.toLowerCase()) !== -1)
          : items;
    }
}

@Pipe({
    name: 'filterDataById'
})
export class FilterDataByIdPipe implements PipeTransform {
    transform(id: number, data: any[]): string {
        if (!data) {
            return '';
        }
        const result = data.filter(item => item.id === id);
        return result[0] && result[0].name ? result[0].name : '';
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/custom-filter.pipe.ts